var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-header',{style:({ height: _vm.headerHeight })},[(_vm.$store.state.isGeneralHeader)?_c('div',[_c('general-header')],1):_c('div',[_c('topic-header')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }